import React, {Component} from 'react';
import { Checkbox } from 'react-icheck';
import PrintPreview from '../PrintPreview';
import TextFieldModal from '../../../component/element/TextFieldModal'
import PdfStore from '../../../stores/PdfStore';
import WorkdocStore from '../../../stores/WorkdocStore';
import Moment from 'moment';
import './Print.css'

var NotificationSystem = require('react-notification-system');
const TODAY = Moment().format('L').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543);
const doctitle = [{title:'ใบเคลม',doc:'copy_claim2'},{title:'ใบขับขี่',doc:'copy_driver_licence'},{title:'ตารางกรมธรรม์',doc:'copy_claim'},
  {title:'พรบ.',doc:'copy_insurance'},{title:'สำเนาทะเบียนรถ',doc:'copy_car'},{title:'บัตรเจ้าของรถ',doc:'copy_id'},{title:'เลขครัชซี',doc:'copy_chassis'},
  {title:'สัญญาประณีประนอมยอมความ',doc:'copy_compromise_agreement'}]
class PrintTNKWorkCoverFileDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {defaultTypePrint:'3',page_title:'กำลังดึงข้อมูล..',dataPage:[{page:0},{page:1}],loading:false, data:{    
    car:{car_registration_no:'',brand:'',model:''},
    insurer:{insurer_id:'',insurer_name:'',claim_no:''},
    receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:'',checking_by:'',openwork_by:''},
    delivering:{delivering_date:''},
    related_detail:{included_doc:this.getEmptyIncludeDoc(),part_from:'',lift_car_from:''
      ,additional_cost:{condition_cost:'',lift_cost:'',advance_lift_cost:'',other_cost:''}},
    doclist:doctitle.map((item,index)=>{
        return {title:item.title,checked:false,doc:item.doc}
      })
    }}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    this.loadWorkCoverFileDoc()
  }

  getEmptyIncludeDoc(){
    return {
      copy_car:false,
      copy_claim:false,
      copy_driver_licence:false,
      copy_id:false,
      copy_insurance:false,
      copy_other:false,
      copy_company_paper:false,
      copy_claim2:false,
      copy_compromise_agreement:false,
      other_text:''
    }
  }

  loadWorkCoverFileDoc() {
    let {workNo} = this.props
    let that = this
    this.setState({ loading: true })
    PdfStore.loadWorkCoverFileDoc(workNo,function(result) {
      let data = result.data

      if(data.related_detail.additional_cost!==undefined){
        data['related_detail']['additional_cost'] = data.related_detail.additional_cost
      }else{
        data['related_detail']['additional_cost'] = that.state.data.related_detail.additional_cost
      }
      if(data.related_detail.included_doc!==undefined){
        data.doclist = that.state.data.doclist.map((item,index)=>{
          if(item.doc in data.related_detail.included_doc){
            item.checked = data.related_detail.included_doc[item.doc]
          }
          
          return item
        })
      } else {
        data['related_detail']['included_doc'] = that.getEmptyIncludeDoc()
        data = JSON.parse(JSON.stringify(data))
      }
      
      data = Object.assign(that.state.data,data)
      that.setState({data:data})
    })  
  }

  saveParkingcarDoc(data){
    let {workNo} = this.props
    let that = this
    WorkdocStore.saveWorkdocRelated(workNo,'parking_doc',data.related_detail,function(result){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบรับรถ ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onCopyPaperChange(index){
    let {data} = this.state
    data.doclist[index].checked = !data.doclist[index].checked
    data.related_detail.included_doc[data.doclist[index].doc] = data.doclist[index].checked
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onCheckChange(field,value){
    let {data} = this.state
    
    if (data['related_detail'][field]===value)
      value = ''

    data['related_detail'][field] = value
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onAccidentChange(field,value) {
    let {data} = this.state
    
    if (data['car'][field]===value)
      value = ''

    data['car'][field] = value
    this.setState({data:data})
    this.saveInfoAccidentType(value)
  }

  saveInfoAccidentType(value) {
    let {workNo} = this.props
    let postData = {wo:workNo,accident_type:value}
    WorkdocStore.saveInfoAccidentType(postData,(result)=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบรับรถ ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },function(){
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })  
  }

  saveInfoExcess(postData) {
    let {workNo} = this.props
    WorkdocStore.saveInfoExcess(postData,(result)=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบรับรถ ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },function(){
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  onOtherSave(fieldInfo){
    let {data} = this.state
    if (data.car.additional_payment===undefined)
      data.car = Object.assign({additional_payment:''}, data.car)
    
    data.car[fieldInfo.item.field] = fieldInfo.value
    this.setState({data:data})
    let postData = JSON.parse(JSON.stringify(data.car))
    postData = Object.assign({wo:this.props.workNo}, postData)
    this.saveInfoExcess(postData)
  }

  onClick(item){
    let fieldInfo = {title:'ใส่ข้อมูล',showClear:true,item:item,value:item.cost }
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  renderSignature() {
    let {receiving} = this.state.data
    return(
      <div className='footer-page'>
        <table className='table table-tnk-work-cover-signature'>
          <tbody>
            <tr>
              <td style={{width:'32%'}} className='text-center'>
                ผู้สั่งซ่อม______________(ลูกค้า)<br/>
                วันที่ {receiving.entrance_date}
              </td>
              <td style={{width:'37%'}} className='text-center'>
                ผู้รับรถเข้า______________(พนักงาน)<br/>
                วันที่ {receiving.entrance_date}
              </td>
              <td style={{width:'31%'}} className='text-center'>
                ผู้รับรถ______________(ลูกค้า)<br/>
                วันที่ ____________
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderHeader(type) {
    let {data} = this.state
    let {owner,car,insurer,receiving,doclist,related_detail} = this.state.data
    let {part_from,lift_car_from} = related_detail
    let {defaultTypePrint} = this.state
    return(
      <div>
        <header>
          <h2 className="text-right">{'ใบรับรถ'}</h2>
        </header>
        <article className={'article-company'}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:'0'}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>             
            </strong>
          </section>
          <section className='sec-copy-doc text-right' style={{float:'right'}}>
            <span style={{display:defaultTypePrint==='0'?'none':''}}>{type}</span>
          </section>
        </article>  
        <div className="font-30" style={{marginTop:'10px'}}>   
          <table className="table table-work-cover-file-doc">
            <tbody>
              <tr>
                <td style={{width:'80px'}}>บริษัท</td>
                <td className='hr2-b text-center color-work-cover-file-doc'>{insurer.insurer_name}</td>
                <td style={{width:'50px'}}>รหัส</td>
                <td style={{fontSize:'40px'}} className='hr2-b hr2-b-print text-center color-work-cover-file-doc work-no'>{this.props.workNo}</td>
              </tr>  
            </tbody>
          </table>
          <table className="table table-tnk-work-cover-file-doc">
            <tbody>      
              <tr>
                <td style={{width:'7%'}}>ยี่ห้อรถ</td>
                <td style={{width:'30%'}} className='hr2-b hr2-b-print text-center'>{car.brand+'/'+car.model}</td>
                <td style={{width:'13%'}}>ทะเบียนรถ</td>
                <td style={{width:'25%'}} className='hr2-b text-center'>{car.car_registration_no}</td>
                <td style={{width:'5%'}}>จังหวัด</td>
                <td style={{width:'20%'}} className='hr2-b text-center'>{car===undefined||car.province===undefined||car.province===null?'':car.province}</td>
              </tr>
            </tbody>
          </table>    
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'28%'}} className='w-c3'>เลขเคลม/เลขรับแจ้ง</td>
                <td style={{width:'72%'}} className='hr2-b text-center hr2-b-print' >{insurer.claim_no}</td>
              </tr>
            </tbody>
          </table>    
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'100px'}} className='w-c3'>ยกรถจาก</td>
                <td className='text-left' colSpan={2}>
                <Checkbox
                    onChange={this.onCheckChange.bind(this,'lift_car_from','garage')}
                    checked={lift_car_from=='garage'}
                    checkboxClass={'icheckbox_square-blue '+(lift_car_from=='garage'?'checkbox-check':'')}
                    increaseArea="20%"
                    label=" อู่"
                  />
                &nbsp;
                <Checkbox
                  onChange={this.onCheckChange.bind(this,'lift_car_from','other')}
                  checked={lift_car_from=='other'}
                  checkboxClass={'icheckbox_square-blue '+(lift_car_from=='other'?'checkbox-check':'')}
                  increaseArea="20%"
                  label=" ที่อื่น"
                /></td>
              </tr>
            </tbody>
          </table>             
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'20%'}} className='w-c5'>ชื่อลูกค้า/ผู้ขับขี่</td>
                <td style={{width:'30%'}} className='hr2-b text-center'>{receiving===undefined||receiving.entrance_name===undefined||receiving.entrance_name===null?'':receiving.entrance_name}</td>
                <td style={{width:'20%'}} className='w-c5'>เบอร์โทรลูกค้า</td>
                <td style={{width:'30%'}} className='hr2-b text-center' >{receiving===undefined||receiving.tel===undefined||receiving.tel===null?'':receiving.tel}</td>
              </tr>
            </tbody>
          </table> 
          <table className="table table-work-cover-file-doc">
            <tbody>   
              <tr>
                <td colSpan={2}>
                  <Checkbox
                      onChange={this.onCheckChange.bind(this,'part_from','garage')}
                      checked={part_from=='garage'}
                      checkboxClass={'icheckbox_square-blue '+(part_from=='garage'?'checkbox-check':'')}
                      increaseArea="20%"
                      label=" อู่จัดอะไหล่"
                    />
                  &nbsp;  
                  <Checkbox
                    onChange={this.onCheckChange.bind(this,'part_from','insurer')}
                    checked={part_from=='insurer'}
                    checkboxClass={'icheckbox_square-blue '+(part_from=='insurer'?'checkbox-check':'')}
                    increaseArea="20%"
                    label=" ประกันจัด"
                  />
                </td>
              </tr>
            </tbody>
          </table>  
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'28%'}} className='w-c3'>วันที่รับเรื่อง/แจ้งซ่อม</td>
                <td style={{width:'22%'}} className='hr2-b text-center hr2-b-print'>{receiving.entrance_date}</td>
                <td style={{width:'28%'}} className='w-c3'>พนักงานอู่รับผิดชอบ</td>
                <td style={{width:'22%'}} className='hr2-b text-center hr2-b-print'>{receiving.checking_by}</td>
              </tr>
            </tbody>
          </table>
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td colSpan={2}>
                      <Checkbox
                        onChange={this.onAccidentChange.bind(this,'accident_type','รถประกัน')}
                        checked={car.accident_type==='รถประกัน'}
                        checkboxClass={'icheckbox_square-blue '+(car.accident_type==='รถประกัน'?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" ประกัน"
                      >
                      </Checkbox>
                      &nbsp;
                      <Checkbox
                        onChange={this.onAccidentChange.bind(this,'accident_type','คู่กรณี')}
                        checked={car.accident_type==='คู่กรณี'}
                        checkboxClass={'icheckbox_square-blue '+(car.accident_type==='คู่กรณี'?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" คู่กรณี"
                      >
                      </Checkbox>
                </td>
              </tr>
            </tbody>
          </table>       
          <div style={{width:'100%'}}>
            <div style={{float:'left',width:'50%'}}>
              <table className="table table-tnk-left-work-cover-file-doc">
                <tbody>
                  <tr>
                    <td>: เอกสารประกอบการ</td>
                  </tr>
                  {
                  doclist.map((item,index)=>(
                    <tr key={index}>
                      <td className='w-claims-doc'>
                        <Checkbox
                          onChange={this.onCopyPaperChange.bind(this,index)}
                          checked={item.checked}
                          checkboxClass={'icheckbox_square-blue '+(item.checked?'checkbox-check':'')}
                          increaseArea="20%"
                          label={" "+item.title}
                        >
                        </Checkbox>
                      </td>
                  </tr>
                  ))}                  
                </tbody>
              </table>  
            </div>
            <div style={{float:'right',width:'50%'}}>
              <table className="table table-tnk-right-work-cover-file-doc" style={{border:"2px solid black"}}>
                <tbody>
                  <tr>
                    <td>: รายละเอียดค่าส่วนต่าง</td>
                    <td></td>
                  </tr>
                  {
                    [{title:'ค่าเสียหายส่วนแรก (Excess)',field:'excess',cost:''},
                    {title:'ค่าส่วนต่าง 50% (ถ้ามี)',field:'50discount',cost:''},
                    {title:'ค่าส่วนต่างลูกค้าจ่ายเพิ่ม (ถ้ามี)',field:'diff_payment',cost:''},
                    {title:'เพิ่มเติม',field:'additional_payment',cost:''}].map((item,index)=>(
                      <tr key={index}>
                        <td>
                          {item.title}
                        </td>
                        <td>
                          <span onClick={this.onClick.bind(this,item)}>...{(car[item.field]!==''&&car[item.field]!==undefined&&car[item.field]!==null)?car[item.field]:'................'}...บาท</span>
                        </td>
                      </tr>
                    ))
                  }                  
                </tbody>
              </table>
            </div>
          </div> 
          {/* <div style={{clear:'both'}}>
            <div className='font-30 text-center' style={{border:'1px solid',padding:'20px'}}>
              "เลขตัวถัง" (เพื่อติดกระดาษคัดลอกเลขตัวถัง)
            </div>
          </div> */}
          {this.renderSignature()}         
          <TextFieldModal ref='textFieldModal'
            confirmTitle='บันทึก'
            onConfirm={this.onOtherSave.bind(this)}
            />
        <NotificationSystem ref="notificationSystem" />                  
        </div>
      </div>  
    )
  }

  renderComponentPage(page,index) {
    let {defaultTypePrint} = this.state
    return(
      <div className='font-print' key={index}>
        <div style={{display:defaultTypePrint==='2'||page===1?'none':''}}>
          {this.renderHeader('ต้นฉบับ')}
        </div>
        <div style={{display:defaultTypePrint==='1'||page===0?'none':''}}>
          {this.renderHeader('สำเนา')}
        </div>
      </div>  
    )
  }

  onTypePrintChange(e) {
  	let {dataPage} = this.state
  	if (e==='1')
  	  dataPage = [{page:0}]
  	else if (e==='2')
  	  dataPage = [{page:1}]
  	else
  	  dataPage = [{page:0},{page:1}]	

  	this.setState({defaultTypePrint:e,dataPage:dataPage})
  }

  render() {
    let {loading,dataPage} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบรับรถ '+this.props.workNo}
        onTypePrintChange={this.onTypePrintChange.bind(this)}
        defaultTypePrint={this.state.defaultTypePrint}
        showPageNumber={false}
      >
        {
          dataPage.map((item,index)=> {
            return this.renderComponentPage(item.page,index)
          })	
        }
      </PrintPreview>
    )
  }

}  

PrintTNKWorkCoverFileDoc.defaultProps = {
  title: 'ใบรับรถ',  
  mode : '1'
}
export default PrintTNKWorkCoverFileDoc;


// WEBPACK FOOTER //
// ./src/view/print/tnk/PrintTNKWorkCoverFileDoc.js